import { Link } from "react-router-dom";
import { AREAS, C, KIND_STYLES } from "./constants";

const Status = ({ p, testId }) => {
  if (!p.enabled) {
    return (
      <div data-testid="tablero-perception-disabled">
        <p className="text-sm" style={{ color: C.text }}>Aún no has activado el Test de Contraste de Percepciones para tu equipo.</p>
        <Link to={`/consulting/${testId}/perception`} className="inline-block mt-3 rounded-full px-5 py-2 text-sm font-semibold text-white" style={{ background: C.green }} data-testid="tablero-perception-open">
          Ir al test de contraste
        </Link>
      </div>
    );
  }
  return (
    <div data-testid="tablero-perception-progress">
      <p className="text-sm" style={{ color: C.text }}>
        {p.threshold_reached ? "Umbral alcanzado. El resumen aparecerá aquí en cuanto esté generado." : "Esperando respuestas del equipo."}
      </p>
      <p className="text-sm font-semibold mt-1" style={{ color: C.green }}>{p.n_responses} de {p.required} respuestas mínimas</p>
      <Link to={`/consulting/${testId}/perception`} className="inline-block mt-3 text-sm font-semibold underline" style={{ color: C.green }}>Ver el test de contraste</Link>
    </div>
  );
};

export const PerceptionByArea = ({ byArea, note }) => (
  <div className="space-y-2" data-testid="tablero-perception-by-area">
    {note && <p className="text-[12px] font-semibold" style={{ color: "#5B6B64" }}>{note}</p>}
    {AREAS.map((a) => {
      const c = byArea[a.code];
      if (!c) return null;
      const s = KIND_STYLES[c.kind] || { bg: "#F1F1EF", fg: C.text };
      return (
        <div key={a.code} className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-white border px-4 py-3" style={{ borderColor: "#E3E7E1" }}>
          <span className="text-sm font-semibold" style={{ color: C.text }}>{a.name}</span>
          <span className="rounded-md px-2 py-0.5 text-[12px] font-bold" style={{ background: s.bg, color: s.fg }}>{c.label}</span>
          {c.nota && <p className="basis-full text-[13px]" style={{ color: "#3F5249" }}>{c.nota}</p>}
        </div>
      );
    })}
  </div>
);

export const PerceptionPanel = ({ p, testId }) => (
  <div data-testid="tablero-perception-panel">
    {p.by_area ? <PerceptionByArea byArea={p.by_area} note="Lectura del Test de Contraste de Percepciones, solo por área." /> : <Status p={p} testId={testId} />}
  </div>
);
